import React, { Fragment,useState,useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react';
import { MobileMENUITEMS } from '../sidebar/menu';
const Footer = (props) => {
  
  useEffect(()=>{
    setInterval(()=>{
      props.setActivetab(window.localStorage.getItem('activetab'))
    },2000)
  },[])
  useEffect(() => {
    props.setActivetab(window.localStorage.getItem('activetab'))
    
  },[window.localStorage.getItem('activetab')]);
  return (
    <Fragment>
      {window.innerWidth <= 991 ?
      <footer className="footer" id="footer">
        <Container fluid={true}>
          <div className="footer-content">
            {
              MobileMENUITEMS.map((Item, i) => {
                return Item.usertype === window.localStorage.getItem("usertype") || Item.usertype === "All"?(
                 
                    <Link to={Item.path} className={Item.active == props.activetab?"maintab activefooter":"maintab"} key={i} onClick={()=>{
                      window.localStorage.setItem('activetab',Item.active)
                              props.setActivetab(Item.active)
                    }}>


                      <Icon icon={Item.icon} width="25" height="25"  />
                      {Item.title}


                    </Link>
                  
                 

                ):""
              })


              // {(Item.type === 'link' && Item.usertype === window.localStorage.getItem("usertype") || Item.usertype === "All") ?




              //     <div className='maintab'>
              //       <Link to={Item.path}>


              //         <Icon icon={Item.icon} width="25" height="25" />
              //         <span>{Item.title}</span>


              //       </Link>
              //       </div>
              //       : ''}








            }
            {/* <div className='maintab'>
              <Icon icon="ant-design:home-filled" color="white" width="25" height="25" />
              Home
            </div>
            <div className='maintab active'>
              <Icon icon="bx:trip" color="#E50014" width="25" height="25" />
              Trip
            </div>
            <div className='maintab'>
              <Icon icon="la:file-invoice" color="white" width="25" height="25" />
              Invoice
            </div>

            <div className='maintab'>
              <Icon icon="bxs:user" color="white" width="25" height="25" />
              Acount
            </div> */}
          </div>
        </Container>
      </footer>:""}
    </Fragment>
  );
}

export default Footer; 